import { theme, UtilityText } from '@policygenius/mortar';
import { styled } from 'styled-components';

export const Tab = styled.div`
  padding: 24px;
`;

// Constrain the reading column: keeps the intro copy at a comfortable line length and
// stops the right-aligned date from drifting to the far edge of a wide case panel.
export const Content = styled.div`
  max-width: 640px;
`;

export const Description = styled(UtilityText)`
  display: block;
  font-style: italic;
  margin: 0 0 16px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 16px 0;
  border-bottom: 1px solid ${theme.colors.gray100};

  &:last-child {
    border-bottom: none;
  }

  svg {
    width: 20px;
    height: 20px;
    flex: none;
    margin-right: 8px;
  }
`;

export const Indicator = styled.div`
  display: flex;
  align-items: center;
`;

export const RowLabel = styled(UtilityText)`
  margin: 0;
`;

export const RowDate = styled(UtilityText)`
  margin: 0 0 0 auto;
`;

export const EmptyState = styled(UtilityText)`
  display: block;
  margin: 0;
`;

export const ErrorState = styled(UtilityText)`
  display: block;
  margin: 0;
`;
